export enum ContactTypeEnum {
  director = 0,
  contact = 1,
}
